import "./Card.scss";

/** 通用白色卡片容器 */
const Card: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={className ? `cs-card ${className}` : "cs-card"}>
      {children}
    </div>
  );
};

export default Card;
